<template>
  <div>
    Filo Kiralama
    <ul>
      <li>Seçili dönem için kiralanan araç adetleri</li>
      <li>toplam çalışan araç adetleri</li>
      <li>Sıfır stok adetleri</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Rental',
}
</script>
